module.exports = "/static/fonts/fontawesome-webfont.674f50d.eot";


//////////////////
// WEBPACK FOOTER
// ./font-awesome/fonts/fontawesome-webfont.eot
// module id = 1126
// module chunks = 2